import {waitFor} from 'src/config/setup/plugins/waitFor/index.js'
import { Channel } from 'src/store/models/index.js'

const ChannelSettings = {
  data: () => ({
  }),
  methods: {
    archiveChannel: waitFor('archiveChannel', async function (channelId, isArchived) {
      if (isArchived) return await Channel.unarchiveChannel(channelId)
      await Channel.archiveChannel(channelId)
    }),
    toggleDisabled: waitFor('toggleChannelDisabledState', async function (channelId, newIsDisabled) {
      await Channel.toggleDisabled(channelId, newIsDisabled)
    }),
    toggleIsMuted (channelId, newIsMuted) {
      Channel.toggleIsMuted(channelId, !newIsMuted)
    },
    togglePinnedState: waitFor('togglePinnedState', async function (channel, isPinned) {
      try {
        await Channel.toggleIsPinned(channel, isPinned)
      } catch {
        await Channel.revertPinnedState(channel, isPinned)
      }
    })
  }
}

export default ChannelSettings
